import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/odin-logo_website.png';
import './Login.css';
import axiosInstance from '../api/axiosInstance';
import { setCookie } from './cookieUtils';

const Login = () => {
  const navigate = useNavigate();
  const [fadeIn, setFadeIn] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    setFadeIn(true);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const res = await axiosInstance.post('/api/auth/login', { email, password }, { withCredentials: true });
      const { username, userId, roles, accessToken } = res.data;
  
      // Set cookies for user info (expires in 1 day, adjust as needed)
      setCookie('token', accessToken, 1);
      setCookie('roles', JSON.stringify(roles), 1);
      setCookie('userId', userId, 1);
      setCookie('username', username, 1);
  
      navigate('/dashboard');
    } catch (err) {
      console.error(err);
      setErrorMessage('Invalid credentials. Please try again.');
    }
  };
  

  return (
    <div className={`login-page ${fadeIn ? 'fade-in' : ''}`}>
      <div className="login-container">
        <div className="logo-wrapper">
          <img src={logo} alt="ODIN Logo" className="login-logo" />
        </div>
        <div className="login-box">
          <h2>Login</h2>
          {errorMessage && (
            <div className="error-message">
              {errorMessage}
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div className="form-content">
              <label className="bold-label" htmlFor="login-email">Email</label>
              <input
                id="login-email"
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />

              <label className="bold-label" htmlFor="login-password">Password</label>
              <input
                id="login-password"
                type="password"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />

              <button type="submit" className="login-button">
                Login
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
